import ResendForm from './resend-form';

export default ResendForm;
